import React, { useState } from 'react';
import ModalBase from './ModalBase';
import { FaInstagram, FaYoutube, FaSpotify } from "react-icons/fa";
import emailjs from "@emailjs/browser";
import { AiFillCheckCircle, AiOutlineArrowUp } from 'react-icons/ai';

const initialState = {
  name: "",
  email: "",
  phone: "",
  message: "",
};

const Contacto = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // };

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   console.log('Form Data:', formData);
  //   // Aquí puedes agregar la lógica para enviar el formulario.
  //   onClose();
  // };

  const [{ name, email, phone, message }, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => {
    setState(initialState);
  };

  const date = new Date();
  const year = date.getFullYear();

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(name, email, phone, message);
    emailjs
      .sendForm("service_mac0a0s", "template_1g7k9cs", e.currentTarget, "V3mgRBfiM1epnbYVg")
      .then(
        (result) => {
          console.log(result.text);
          setLoading(false);
          setSuccess(true);
          clearState();
        },
        (error) => {
          console.log(error.text);
          setLoading(false);
          alert("Error al enviar el mensaje, contactarse a magnesio1864@gmail.com");
        }
      )
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
          setSuccess(false);
        }, 2000);
      });
  };



  return (
    <ModalBase isOpen={isOpen} onClose={onClose} title="Contacto">
      <div className='overflow-hidden'>
        <form name="sentMessage" noValidate onSubmit={handleSubmit}>
          <div className="relative mb-6 mt-2" data-te-input-wrapper-init>
            <input
              type="text"
              id="name"
              name="name"
              className="peer block border border-gray-400 min-h-[auto] w-full rounded  bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none   dark:peer-focus:text-primary [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
              placeholder="Name"
              required
              value={name}
              onChange={handleChange}
            />
            <label
              className={`${name !== "" ? "-translate-y-[0.9rem] scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none" : ""} pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6]  transition-all duration-200 ease-out `}
              htmlFor="name">Nombre
            </label>
          </div>

          <div className="relative mb-6" data-te-input-wrapper-init>
            <input
              type="email"
              id="email"
              name="email"
              className="peer block border border-gray-400 min-h-[auto] w-full rounded  bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none   dark:peer-focus:text-primary [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
              placeholder="Email"
              required
              value={email}
              onChange={handleChange}
            />
            <label
              className={`${email !== "" ? "-translate-y-[0.9rem] scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none" : ""} pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6]  transition-all duration-200 ease-out `}
              htmlFor="email">Email
            </label>
          </div>
          <div className="relative mb-6" data-te-input-wrapper-init>
            <input
              type="number"
              id="phone"
              name="phone"
              className="peer block border border-gray-400 min-h-[auto] w-full rounded  bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 peer-focus:text-primary data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none   dark:peer-focus:text-primary [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
              placeholder="Telefono"
              value={phone}
              onChange={handleChange}
            />
            <label
              className={`${phone !== "" ? "-translate-y-[0.9rem] scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none" : ""} pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6]  transition-all duration-200 ease-out `}
              htmlFor="phone">Telefono
            </label>
          </div>
          <div className="relative mb-6" data-te-input-wrapper-init>
            <textarea
              name="message"
              id="message"
              className="peer block border border-gray-400 min-h-[auto] w-full rounded  bg-transparent py-[0.32rem] px-3 leading-[1.6] outline-none transition-all duration-200 ease-linear focus:placeholder:opacity-100 data-[te-input-state-active]:placeholder:opacity-100 motion-reduce:transition-none   [&:not([data-te-input-placeholder-active])]:placeholder:opacity-0"
              rows={4}
              placeholder="Message"
              required
              value={message}
              onChange={handleChange}
            ></textarea>
            <label htmlFor="message"
              className={`${message !== "" ? "-translate-y-[0.9rem] scale-[0.8] peer-focus:text-primary peer-data-[te-input-state-active]:-translate-y-[0.9rem] peer-data-[te-input-state-active]:scale-[0.8] motion-reduce:transition-none" : ""} pointer-events-none absolute top-0 left-3 mb-0 max-w-[90%] origin-[0_0] truncate pt-[0.37rem] leading-[1.6]  transition-all duration-200 ease-out `}
            >Mensaje</label>
          </div>
          <div className='flex items-center justify-center w-full'>
          <button type="submit" disabled={loading || !name || !email || !message} className={`${success ? '!bg-green-500' : ''} w-3/5 p-2 hover:scale-105 active:scale-95 bg-blue-500 flex items-center justify-center text-white rounded hover:bg-blue-600 disabled:!cursor-not-allowed disabled:bg-gray-500 disabled:hover:!scale-100 `} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            {loading ? "Enviando..." : success ? <AiFillCheckCircle className="text-white  w-8 h-8" /> : "Enviar"}
          </button>
          </div>
          
        </form>

        {/* Iconos de redes sociales */}
        <div className="flex justify-center mt-4 space-x-6 text-2xl ">
          <a className='text-rose-500 hover:scale-110 active:scale-95' href="https://www.instagram.com/magnesio1864/" target="_blank" rel="noopener noreferrer">
            <FaInstagram />
          </a>
          <a className='text-green-700 hover:scale-110 active:scale-95' href="https://open.spotify.com/artist/2PUW2ABOG4j50nsUJBr7ZP?si=chX2srlJRWWJaq3Trd1zzw" target="_blank" rel="noopener noreferrer">
            <FaSpotify />
          </a>
          <a className='text-red-600 hover:scale-110 active:scale-95' href="https://www.youtube.com/@Magnesio1864" target="_blank" rel="noopener noreferrer">
            <FaYoutube />
          </a>
        </div>
      </div>

    </ModalBase>
  );
};

export default Contacto;
